export enum DividerType {
  Solid = 'solid',
  Dashed = 'dashed',
  Dotted = 'dotted',
}
